var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "explore-tokens md-layout md-alignment-center-center md-layout-item md-size-80 md-xsmall-size-100"
    },
    [
      !_vm.tokens.length
        ? [
            _c(
              "div",
              { staticClass: "app__no-data-msg container container_30" },
              [
                _c(
                  "md-card",
                  { staticClass: "md-layout-item md-size-100" },
                  [
                    _c(
                      "md-card-content",
                      [
                        _c("md-icon", { staticClass: "md-size-4x" }, [
                          _vm._v("toll")
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v(_vm._s(_vm.i18n.tr_no_assets()))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.i18n.tr_no_assets_exp()))])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _c(
            "md-card",
            { staticClass: "explore-tokens__card container" },
            [
              _c("md-card-header", [
                _c("div", { staticClass: "md-title" }, [
                  _vm._v(_vm._s(_vm.i18n.lbl_explore_tokens()))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "explore-tokens__inner" },
                [
                  _c(
                    "div",
                    { staticClass: "explore-tokens__list" },
                    [
                      _vm.tokens.length
                        ? [
                            _c(
                              "md-content",
                              { staticClass: "md-scrollbar scrollbar" },
                              [
                                _c(
                                  "md-list",
                                  [
                                    _vm._l(_vm.tokens, function(token, i) {
                                      return [
                                        _c(
                                          "md-list-item",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.selectToken(token)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "md-avatar",
                                              {
                                                staticClass: "md-avatar-icon",
                                                class:
                                                  "" +
                                                  (_vm.hasBalance(token)
                                                    ? "md-primary"
                                                    : "md-accent")
                                              },
                                              [
                                                token.logoUrl
                                                  ? [
                                                      _c("img", {
                                                        attrs: {
                                                          src: token.logoUrl,
                                                          alt: _vm.avatar(
                                                            token.code
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  : [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.avatar(token.code)
                                                        )
                                                      )
                                                    ]
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "explore-tokens__token-name",
                                                class: {
                                                  selected:
                                                    _vm.selected.code ===
                                                    token.code
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text_medium"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(token.code) +
                                                        "\n                        "
                                                    ),
                                                    _vm.hasBalance(token)
                                                      ? _c(
                                                          "md-icon",
                                                          {
                                                            staticClass:
                                                              "explore-tokens__balance-exists-icon md-icon--half-sized"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "check_circle"
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text_medium"
                                                  },
                                                  [_vm._v(_vm._s(token.name))]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.selected
                    ? [
                        _c(
                          "md-card",
                          { staticClass: "explore-tokens__details details" },
                          [
                            _c(
                              "div",
                              { staticClass: "details__header" },
                              [
                                _c(
                                  "md-avatar",
                                  {
                                    staticClass: "md-avatar-icon",
                                    class:
                                      "" +
                                      (_vm.hasBalance(_vm.selected)
                                        ? "md-primary"
                                        : "md-accent")
                                  },
                                  [
                                    _vm.selected.logoUrl
                                      ? [
                                          _c("img", {
                                            attrs: {
                                              src: _vm.selected.logoUrl,
                                              alt: _vm.avatar(_vm.selected.code)
                                            }
                                          })
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(
                                              _vm.avatar(_vm.selected.code)
                                            )
                                          )
                                        ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "details__main-info text_medium"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.selected.code))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.selected.name))
                                    ]),
                                    _vm._v(" "),
                                    _vm.hasBalance(_vm.selected)
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "explore-tokens__balance-exists-msg"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.i18n.lbl_balance_exists()
                                                ) +
                                                "\n                    "
                                            ),
                                            _c(
                                              "md-icon",
                                              {
                                                staticClass:
                                                  "explore-tokens__balance-exists-icon md-icon--half-sized"
                                              },
                                              [_vm._v("check_circle")]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "details__info" }, [
                              _c(
                                "div",
                                { staticClass: "text_medium text_bold" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.i18n.lbl_token_details()) + ":"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "detail-row text_medium" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.i18n.lbl_code()))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.selected.code))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "detail-row text_medium" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.i18n.lbl_available()))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.roundCurrency(
                                          _vm.selected.available,
                                          _vm.selected.code
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "detail-row text_medium" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.i18n.lbl_name()))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.selected.name))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "detail-row text_medium" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.i18n.lbl_maximum()))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.roundCurrency(
                                          _vm.selected.max,
                                          _vm.selected.code
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "detail-row text_medium" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.i18n.lbl_issued()))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.roundCurrency(
                                          _vm.selected.issued,
                                          _vm.selected.code
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.selected.termsUrl
                                ? _c(
                                    "div",
                                    { staticClass: "detail-row text_medium" },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.i18n.lbl_terms()))
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.selected.termsUrl))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "md-card-actions",
                              { staticClass: "explore-tokens__token-actions" },
                              [
                                !_vm.hasBalance(_vm.selected)
                                  ? _c(
                                      "md-button",
                                      {
                                        staticClass: "md-primary btn",
                                        attrs: { disabled: _vm.isPending },
                                        on: { click: _vm.createBalance }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.i18n.lbl_add_to_balances()
                                          ) + "\n            "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "md-button",
                                      {
                                        staticClass: "md-primary btn",
                                        on: { click: _vm.goHistory }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.i18n.lbl_view_history()) +
                                            "\n            "
                                        )
                                      ]
                                    )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07bf5714", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07bf5714","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/tokens/Tokens.Explore.vue
// module id = bbzj
// module chunks = 1